import { useCallback } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';

export const useClearEditorText = () => {
  const [editor] = useLexicalComposerContext();

  const clearEditorText = useCallback(() => {
    editor.update(() => {
      const root = $getRoot();
      root.getChildren().forEach((child) => child.remove());
    });
  }, [editor]);

  return { clearEditorText };
};
